import * as yup from 'yup';

const ADDRESS_API_URL = `${window.location.origin}/api/v3/openserviceproxy/adresser`;

interface AddressSearchResponse {
	status: string;
	fund?: { type: string; titel: string }[];
}

const addressValidationCache = new Map<string, boolean>();

// Valid only when the text exactly matches a full 'adresse' result, i.e. the user completed the cascade
const isValidAddress = async (value: string): Promise<boolean> => {
	const key = value.trim().toLowerCase();
	if (addressValidationCache.has(key)) return addressValidationCache.get(key);

	try {
		const res = await fetch(`${ADDRESS_API_URL}/soeg?tekst=${encodeURIComponent(value.trim())}`);
		if (!res.ok) return false;
		const json = (await res.json()) as AddressSearchResponse;
		const isValid =
			json?.status === 'ok' &&
			!!json.fund?.some((f) => f.type === 'adresse' && f.titel.trim().toLowerCase() === key);
		addressValidationCache.set(key, isValid);
		return isValid;
	} catch (e) {
		console.error(e);
		return false;
	}
};

yup.addMethod<yup.StringSchema>(yup.string, 'validDawaAddress', function (message) {
	return this.test('dawa-test', 'Address is not a valid DAWA address', async function (value) {
		const { path, createError } = this;
		if (!value) {
			return true;
		}

		return (await isValidAddress(value))
			? true
			: createError({
					message: message || 'Address is not a valid DAWA address',
					path: path,
			  });
	});
});

export default yup;
